export default "__VITE_ASSET__VAR4qJ2L__"